/** Feedback: anybody writes to the team; admins and root read the inbox. */
import { baseApi } from '../baseApi';
import type { FeedbackIn, FeedbackItem, FeedbackPage, FeedbackSent } from '../types';

export type FeedbackState = 'open' | 'handled' | 'all';

export const feedbackApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // With an account or without: the server reads the session if there is one.
    sendFeedback: build.mutation<FeedbackSent, FeedbackIn>({
      query: (body) => ({ url: '/feedback', method: 'POST', body }),
      invalidatesTags: ['Feedback'],
    }),
    listFeedback: build.query<FeedbackPage, { state: FeedbackState; cursor?: number | undefined }>({
      query: (params) => ({ url: '/feedback/inbox', params }),
      providesTags: ['Feedback'],
    }),
    markFeedback: build.mutation<FeedbackItem, { id: string; handled: boolean }>({
      query: ({ id, handled }) => ({ url: `/feedback/inbox/${id}`, method: 'PATCH', body: { handled } }),
      invalidatesTags: ['Feedback'],
    }),
  }),
});

export const { useSendFeedbackMutation, useListFeedbackQuery, useMarkFeedbackMutation } = feedbackApi;
